var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center py-5"},[_c('div',[_c('font-awesome-icon',{staticStyle:{"font-size":"64px","color":"#e7e7e7"},attrs:{"icon":"inbox"}})],1),_c('div',{staticClass:"text-info mt-2"},[_vm._t("default",function(){return [_vm._v("暂无数据")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }